export default () => {
  return {
    workflows: [],

    /**
     * Timestamps of last time workflows were fetched per workflow ID
     * We use this to determine if we need to reload the cached workflows
     */
    workflowsLastFetchTimestamp: {},

  };
};
